// extracted by mini-css-extract-plugin
export default {"recaptcha_wrapper":"SurveyForm_recaptcha_wrapper__EwbRT"};